import WidgetItem from './WidgetItem';

export default WidgetItem;
